var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2738 16.7362L17.5238 30.3542L3.77383 16.7362C2.86689 15.8537 2.1525 14.7929 1.67566 13.6207C1.19882 12.4486 0.969856 11.1903 1.00318 9.92529C1.0365 8.66026 1.33139 7.41583 1.86928 6.27036C2.40717 5.1249 3.17641 4.10321 4.12855 3.26964C5.08069 2.43607 6.19512 1.80868 7.40165 1.42696C8.60818 1.04525 9.88067 0.917484 11.139 1.05172C12.3973 1.18595 13.6142 1.57927 14.7131 2.20691C15.812 2.83455 16.7689 3.68291 17.5238 4.69858C18.282 3.69029 19.2401 2.84933 20.3382 2.22836C21.4363 1.60738 22.6507 1.21974 23.9055 1.0897C25.1603 0.959663 26.4285 1.09003 27.6306 1.47263C28.8327 1.85524 29.9429 2.48185 30.8917 3.31325C31.8405 4.14465 32.6074 5.16293 33.1446 6.30438C33.6818 7.44583 33.9775 8.68587 34.0134 9.94688C34.0493 11.2079 33.8245 12.4627 33.3531 13.6329C32.8817 14.803 32.1738 15.8633 31.2738 16.7472",
    stroke: "#001F4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b118b97b5f3eedcdf31c9ec1bbd791a5.svg";
export { ForwardRef as ReactComponent };